import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Briefcase, CheckCircle, ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import ScrollReveal from "@/components/ui/scroll-reveal";

const LavoraConNoiBanner = () => {
  const { t } = useLanguage();
  const b = t.lavoraBanner;

  return (
    <ScrollReveal>
      <section className="py-10 px-4 sm:px-6 bg-primary/5 border-y border-primary/15">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6 lg:gap-10">
            <div className="flex items-start gap-4 flex-1">
              <div className="w-12 h-12 rounded-xl bg-primary/15 flex items-center justify-center shrink-0 mt-0.5">
                <Briefcase className="w-6 h-6 text-primary" />
              </div>
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-lg font-bold font-heading">{b.title}</h3>
                  <span className="bg-accent text-accent-foreground text-[10px] font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wide">
                    {b.badge}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed mb-3">{b.text}</p>
                <div className="flex flex-col sm:flex-row gap-x-6 gap-y-1.5 text-xs text-muted-foreground">
                  {b.highlights.map((h, i) => (
                    <span key={i} className="flex items-center gap-1.5">
                      <CheckCircle className="w-3.5 h-3.5 text-primary shrink-0" />
                      {h}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <Button variant="cta" className="shrink-0" asChild>
              <Link to="/contatti/lavora-con-noi">
                {b.cta} <ArrowRight className="w-4 h-4 ml-1" />
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
};

export default LavoraConNoiBanner;
